import {NavMenuItem} from '../core/models/nav-menu-item.interface';
import {environment} from '../../environments/environment';
const hideCharts = environment.hideCharts;
export const MENU_ITEMS = [
  {
    title: 'KF CHARTS',
    code: 'kfcharts',
    roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
    link: 'kfcharts',
    breadcrumb_title: 'KF Charts',
    class: '',
    submenus: [
      {
        title: 'WEEE FORUM',
        code: 'weeesystem',
        pageTitle: 'KF Charts',
        pageSubtitle: 'WEEE System',
        breadcrumb_title: 'WEEE System',
        link: 'weeesystem',
        showLateralMenuTitle: true,
        submenus: [
          {
            title: 'Put on Market',
            code: 'kfcharts.WeeeSystem.PutOnMarket',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Put On Market',
            breadcrumb_title: 'Put On Market',
            link: 'kfcharts/weeesystem/putonmarket',
            submenus: [
              {
                title: 'Country vs WEEE Forum',
                link: '/kfcharts/weeesystem/putonmarket/countryvsweeeforum',
                code: 'kfcharts.WeeeSystem.PutOnMarket.CountryVsWeeeForum'
              },
            ]
          },
          {
            title: 'Collected',
            code: 'kfcharts.WeeeSystem.Collected',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Collected',
            breadcrumb_title: 'Collected',
            link: 'kfcharts/weeesystem/collected',
            submenus: [
              {
                title: 'Country vs WEEE Forum',
                link: '/kfcharts/weeesystem/collected/countryvsweeeforum',
                code: 'kfcharts.WeeeSystem.Collected.CountryVsWeeeForum'
              },
            ]
          },
          {
            title: 'Return Rate',
            code: 'kfcharts.WeeeSystem.ReturnRate',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Return Rate',
            breadcrumb_title: 'Return Rate',
            link: '/kfcharts/weeesystem/returnrate',
            submenus: [
              {
                title: 'Benchmark By Year',
                link: '/kfcharts/weeesystem/returnrate/benchmark',
                code: 'kfcharts.WeeeSystem.ReturnRate.BenchmarkByYear'
              },
            ]
          },
          {
            title: 'Recycle %',
            code: 'kfcharts.WeeeSystem.Recycle',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Recycle %',
            breadcrumb_title: 'Recycle %',
            link: '/kfcharts/weeesystem/recycle',
            submenus: [
              {
                title: 'By Collection Stream',
                link: '/kfcharts/weeesystem/recycle/collection',
                code: 'kfcharts.WeeeSystem.Recycle.ByCollectionStream'
              },
            ]
          },
          {
            title: 'Cost',
            code: 'kfcharts.WeeeSystem.Cost',
            roles: ['WF_ADMIN', 'ALL'],
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Cost',
            breadcrumb_title: 'Cost',
            link: '/kfcharts/weeesystem/cost',
            submenus: [
              {
                title: 'Benchmark Operational Costs',
                link: '/kfcharts/weeesystem/cost/operational',
                code: 'kfcharts.WeeeSystem.Cost.BenchmarkOperationalCost'
              },
              {
                title: 'Benchmark Overhead Costs',
                link: '/kfcharts/weeesystem/cost/overheads',
                code: 'kfcharts.WeeeSystem.Cost.BenchmarkOverheadCost'
              },
              {
                title: 'Operations vs. Overhead costs',
                link: '/kfcharts/weeesystem/cost/operations-vs-overhead',
                code: 'kfcharts.WeeeSystem.Cost.OperationsVsOverhead',
                roles: ['WF_ADMIN'],
              },
              {
                title: 'Payments to Collection points',
                link: '/kfcharts/weeesystem/cost/additional',
                code: 'kfcharts.WeeeSystem.Cost.Additional'
              },
            ]
          },
          {
            title: 'Download KF Data',
            code: 'kfcharts.download',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Download KF Data',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            breadcrumb_title: 'Download KF Data',
            link: '/kfcharts/weeesystem/download',
          },
        ]
      },
      {
        title: 'COUNTRY',
        code: 'country',
        pageTitle: 'KF Charts',
        pageSubtitle: 'Country',
        breadcrumb_title: 'Country',
        link: 'country',
        showLateralMenuTitle: true,
        submenus: [
          {
            title: 'Put on Market',
            code: 'kfcharts.Country.PutOnMarket',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'Country Charts',
            pageSubtitle: 'Put On Market',
            breadcrumb_title: 'Put On Market',
            link: 'kfcharts/country/putonmarket',
            submenus: [
              {
                title: 'European trend',
                link: '/kfcharts/country/putonmarket/europeantrend',
                code: 'kfcharts.Country.PutOnMarket.EuropeanTrend'
              },
              {
                title: 'Trend by country',
                link: '/kfcharts/country/putonmarket/trendbycountry',
                code: 'kfcharts.Country.PutOnMarket.TrendByCountry'
              },
              {
                title: 'Benchmark By Year',
                link: '/kfcharts/country/putonmarket/benchmarkbyyear',
                code: 'kfcharts.Country.PutOnMarket.BenchmarkByYear'
              },
              {
                title: 'Country vs WEEE Forum',
                link: '/kfcharts/country/putonmarket/countryvsweeeforum',
                code: 'kfcharts.Country.PutOnMarket.CountryVsWeeeForum'
              },
              {title: 'Composition', link: '/kfcharts/country/putonmarket/composition', code: 'kfcharts.Country.PutOnMarket.Composition'},
            ]
          },
          {
            title: 'Collected',
            code: 'kfcharts.Country.Collected',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'Country Charts',
            pageSubtitle: 'Collected',
            breadcrumb_title: 'Collected',
            link: 'kfcharts/country/collected',
            submenus: [
              // tslint:disable-next-line:max-line-length
              {
                title: 'European trend',
                link: '/kfcharts/country/collected/europeantrend',
                code: 'kfcharts.Country.Collected.EuropeanTrend'
              },
              {
                title: 'Trend by country',
                link: '/kfcharts/country/collected/trendbycountry',
                code: 'kfcharts.Country.Collected.TrendByCountry'
              },
              {
                title: 'Benchmark By Year',
                link: '/kfcharts/country/collected/benchmarkbyyear',
                code: 'kfcharts.Country.Collected.BenchmarkByYear'
              },
              {
                title: 'Country vs WEEE Forum',
                link: '/kfcharts/country/collected/countryvsweeeforum',
                code: 'kfcharts.Country.Collected.CountryVsWeeeForum'
              },
              {title: 'Composition', link: '/kfcharts/country/collected/composition', code: 'kfcharts.Country.Collected.Composition'},
              // tslint:disable-next-line:max-line-length
              {
                title: 'EU Collection Target up to 2018',
                link: '/kfcharts/country/collected/vctupto2018',
                code: 'kfcharts.Country.Collected.CollectionTargetUpTo2018'
              },
              {
                title: 'EU Collection Target Performance up to 2018',
                link: '/kfcharts/country/collected/vctpupto2018',
                code: 'kfcharts.Country.Collected.CollectionTargetPerformanceUpTo2018'
              },
              // tslint:disable-next-line:max-line-length
              {
                title: 'EU Collection Target from 2019',
                link: '/kfcharts/country/collected/vctfrom2019',
                code: 'kfcharts.Country.Collected.CollectionTargetFrom2019'
              },
              {
                title: 'EU Collection Target Performance from 2019',
                link: '/kfcharts/country/collected/vctpfrom2019',
                code: 'kfcharts.Country.Collected.CollectionTargetPerformanceFrom2019'
              },
            ]
          },
          {
            title: 'Return rate',
            code: 'kfcharts.Country.ReturnRate',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            pageTitle: 'Country Charts',
            pageSubtitle: 'Return Rate',
            breadcrumb_title: 'Return Rate',
            link: 'kfcharts/country/returnrate',
            submenus: [
              {
                title: 'Trend by country',
                link: '/kfcharts/country/return/trendbycountry',
                code: 'kfcharts.Country.ReturnRate.TrendByCountry'
              },
              {title: 'By Year', link: '/kfcharts/country/return/byyear', code: 'kfcharts.Country.ReturnRate.ByYear'},
            ]
          },
          {
            title: 'Download KF Data',
            code: 'kfcharts.download',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Download KF Data',
            roles: ['WF_ADMIN', 'COLLECTED', 'ALL'],
            breadcrumb_title: 'Download KF Data',
            link: '/kfcharts/country/download',
          },
        ]
      }
    ]
  } as NavMenuItem,
  {
    title: 'INTELLIGENCE CHARTS',
    code: 'intelligence',
    roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS'],
    link: 'intelligence',
    breadcrumb_title: 'Intelligence',
    submenus: [
      {
        title: 'WEEE FORUM',
        code: 'weeesystem',
        pageTitle: 'Intelligence',
        pageSubtitle: 'WEEE System',
        breadcrumb_title: 'WEEE System',
        link: 'weeesystem',
        showLateralMenuTitle: true,
        submenus: [
          {
            title: 'WEEE system collection: retails vs. municipality vs. other',
            code: 'intelligence.WeeeSystem.RetailVsMunicipalitiesVsOther',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: '% of WEEE collected from retail vs municipalities vs other',
            breadcrumb_title: '% of WEEE collected from retail vs municipalities vs other',
            link: 'intelligence/weeesystem/retail-vs-municipalities-vs-other',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Number of members adhered',
            code: 'intelligence.WeeeSystem.MembersAdhered',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Number of members adhered',
            breadcrumb_title: 'Number of members adhered',
            link: 'intelligence/weeesystem/members-adhered',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Network of recycling facilities per PRO',
            code: 'intelligence.WeeeSystem.NetworkRecyclingFacilities',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Network of recycling facilities per PRO',
            breadcrumb_title: 'Network of recycling facilities per PRO',
            link: 'intelligence/weeesystem/network-recycling-facilities',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Collection points serviced by WF members',
            code: 'intelligence.WeeeSystem.CollectionPointsOperated',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Collection points serviced by WF members',
            breadcrumb_title: 'Collection points serviced by WF members',
            link: 'intelligence/weeesystem/collection-points-operated',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Employees per PRO',
            code: 'intelligence.WeeeSystem.EmployeesPerPro',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Employees per PRO',
            breadcrumb_title: 'Employees per PRO',
            link: 'intelligence/weeesystem/employees-per-pro',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Download System and Countries at a glance',
            code: 'intelligence.download',
            pageTitle: 'WEEE System Charts',
            pageSubtitle: 'Download System and Countries at a glance',
            breadcrumb_title: 'Download System and Countries at a glance',
            link: 'intelligence/weeesystem/download',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
        ]
      },
      {
        title: 'COUNTRY',
        code: 'country',
        pageTitle: 'Intelligence',
        pageSubtitle: 'Country',
        breadcrumb_title: 'Country',
        link: 'country',
        showLateralMenuTitle: true,
        submenus: [
          {
            title: 'Categories in scope of e-waste legislation',
            code: 'intelligence.Country.EWasteLegislation',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Categories in scope of e-waste legislation',
            breadcrumb_title: 'Categories in scope of e-waste legislation',
            link: 'intelligence/country/e-waste-legislation',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Number of systems in the country',
            code: 'intelligence.Country.SystemsInCountry',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Number of systems in the country',
            breadcrumb_title: 'Number of systems in the country',
            link: 'intelligence/country/systems-in-country',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Use of fees',
            code: 'intelligence.Country.VisibleFee',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Use of fees',
            breadcrumb_title: 'Use of fees',
            link: 'intelligence/country/visible-fee',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Countries with re-use targets',
            code: 'intelligence.Country.ReUseTargets',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Countries with re-use targets',
            breadcrumb_title: 'Countries with re-use targets',
            link: 'intelligence/country/re-use-targets',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Mandatory WEEE treatment standards',
            code: 'intelligence.Country.WeeeTreatmentStandardMandatory',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Is there a WEEE treatment standard mandatory?',
            breadcrumb_title: 'Is there a WEEE treatment standard mandatory?',
            link: 'intelligence/country/weee-treatment-standard-mandatory',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Country collection: retails vs. municipality vs. other',
            code: 'intelligence.Country.RetailVsMunicipalitiesVsOther',
            pageTitle: 'Country Charts',
            pageSubtitle: '% of WEEE collected from retail vs municipalities vs other',
            breadcrumb_title: '% of WEEE collected from retail vs municipalities vs other',
            link: 'intelligence/country/retail-vs-municipalities-vs-other',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
          {
            title: 'Download System and Countries at a glance',
            code: 'intelligence.download',
            pageTitle: 'Country Charts',
            pageSubtitle: 'Download System and Countries at a glance',
            breadcrumb_title: 'Download System and Countries at a glance',
            link: 'intelligence/country/download',
            roles:   ['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL'],
          },
        ]
      },
    ]
  } as NavMenuItem,
  {
    title: 'KF DATA ENTRY',
    code: 'kfdataentry',
    roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN'],
    link: 'kfdataentry',
    breadcrumb_title: 'KF Data Entry',
    class: '',
    submenus: [
      {
        title: 'SYSTEM',
        code: 'weeesystem',
        pageTitle: 'System',
        pageSubtitle: 'System',
        breadcrumb_title: 'System',
        link: 'weeesystem/kfconfiguration',
        class: '',
        roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN'],
        submenus: [
          {
            title: 'KF Configuration',
            code: 'systemkeyfigurereports',
            pageTitle: 'Kf Reporting',
            pageSubtitle: 'Key Figures Configurations',
            breadcrumb_title: 'KF Configurations',
            link: 'kfdataentry/weeesystem/kfconfiguration',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN']
          },
          {
            title: 'KF Registration',
            code: 'keyfigureentry.WeeeSystem.All',
            pageTitle: 'KF Registration',
            pageSubtitle: 'Key Figures Registration',
            breadcrumb_title: 'KF Registration',
            link: 'kfdataentry/weeesystem/kfregistration/all',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN'],
            submenus: [
              {title: 'All Registrations', link: '/kfdataentry/weeesystem/kfregistration/all', code: 'keyfigureentry.WeeeSystem.All'},
              {
                title: 'Put on Market',
                link: '/kfdataentry/weeesystem/kfregistration/putonmarket',
                code: 'keyfigureentry.WeeeSystem.PutOnMarket'
              },
              // tslint:disable-next-line:max-line-length
              {title: 'Collected', link: '/kfdataentry/weeesystem/kfregistration/collected', code: 'keyfigureentry.Weeesystem.Collected'},
              {title: 'Cost', link: '/kfdataentry/weeesystem/kfregistration/cost', code: 'keyfigureentry.Weeesystem.Cost'},
              {title: 'Recycle %', link: '/kfdataentry/weeesystem/kfregistration/recycling', code: 'keyfigureentry.Weeesystem.Recycling'},
            ]
          },
        ]
      },
      {
        title: 'COUNTRY',
        code: 'country',
        pageTitle: 'Country',
        pageSubtitle: 'Country',
        breadcrumb_title: 'Country',
        link: 'country/kfconfiguration',
        class: '',
        roles: ['WS_COUNTRY_COORDINATOR'],
        submenus: [
          {
            title: 'KF Configuration',
            code: 'countrykeyfigurereports',
            pageTitle: 'Kf Reporting',
            pageSubtitle: 'Key Figures Configurations',
            breadcrumb_title: 'KF Configurations',
            link: 'kfdataentry/country/kfconfiguration',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR']
          },
          {
            title: 'KF Registration',
            code: 'keyfigureentry.Country.All',
            pageTitle: 'KF Registration',
            pageSubtitle: 'Key Figures Registration',
            breadcrumb_title: 'KF Registration',
            link: 'kfdataentry/country/kfregistration/all',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR'],
            submenus: [
              {title: 'All Registrations', link: '/kfdataentry/country/kfregistration/all', code: 'keyfigureentry.Country.All'},
              {title: 'Put on Market', link: '/kfdataentry/country/kfregistration/putonmarket', code: 'keyfigureentry.Country.Putonmarket'},
              {title: 'Collected', link: '/kfdataentry/country/kfregistration/collected', code: 'keyfigureentry.Country.Collected'},
            ]
          },
        ]
      },
    ]
  } as NavMenuItem,
  {
    title: 'INTELLIGENCE DATA ENTRY',
    code: 'intelligencedata',
    roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN'],
    link: 'intelligencedata',
    breadcrumb_title: 'Intelligence Data Entry',
    class: '',
    submenus: [
      {
        title: 'SYSTEM',
        code: 'weeesystem',
        pageTitle: 'System',
        pageSubtitle: 'System',
        breadcrumb_title: 'System',
        link: 'weeesystem/answerforms',
        class: '',
        roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN'],
        submenus: [
          {
            title: 'List of Forms',
            code: 'answerforms',
            pageTitle: 'Kf Reporting',
            pageSubtitle: 'Key Figures Configurations',
            breadcrumb_title: 'KF Configurations',
            link: 'intelligencedata/weeesystem/answerforms',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR', 'WS_ADMIN']
          }
        ]
      },
      {
        title: 'COUNTRY',
        code: 'country',
        pageTitle: 'Country',
        pageSubtitle: 'Country',
        breadcrumb_title: 'Country',
        link: 'country/answerforms',
        class: '',
        roles: ['WS_COUNTRY_COORDINATOR'],
        submenus: [
          {
            title: 'List of Forms',
            code: 'answerforms',
            pageTitle: 'Kf Reporting',
            pageSubtitle: 'Key Figures Configurations',
            breadcrumb_title: 'KF Configurations',
            link: 'intelligencedata/country/answerforms',
            class: '',
            roles: ['WS_COUNTRY_COORDINATOR']
          }
        ]
      },
    ]
  } as NavMenuItem,
  {
    // tslint:disable-next-line:max-line-length
    title: 'KFREPORTING',
    code: 'kfreporting',
    roles: ['WF_ADMIN'],
    link: 'kfreporting',
    breadcrumb_title: 'Kf Reporting',
    class: '',
    submenus: [
      {
        title: 'CLASSIFIERS',
        code: 'classifiers',
        pageTitle: 'Classifiers',
        pageSubtitle: 'Classifiers',
        breadcrumb_title: 'Classifiers',
        link: '/classifiers/unu-keys',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'UNU-Keys', link: '/kfreporting/classifiers/unu-keys', code: 'unu-keys'},
          {title: 'Put On Market Categories', link: '/kfreporting/classifiers/kf-categories', code: 'kf-categories'},
          {title: 'Collection Streams', link: '/kfreporting/classifiers/collection-streams', code: 'collection-streams'}
        ]
      },
      {
        title: 'KF CONFIGURATION',
        code: 'kfconfiguration',
        pageTitle: 'Kf Reporting',
        pageSubtitle: 'Report Cycles',
        breadcrumb_title: 'KF Configuration',
        link: '/kfconfiguration/reportcycles',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'Next Report Cycle', link: '/kfreporting/kfconfiguration/nextreportcycle', code: 'admin.kfreporting.nextreportcycle'},
          {title: 'Report Cycles', link: '/kfreporting/kfconfiguration/reportcycles', code: 'admin.kfreporting.reportcycles'},
          {title: 'KF Configurations', link: '/kfreporting/kfconfiguration/configurations', code: 'admin.kfreporting.configurations'},
          {title: 'Mapping By Country', link: '/kfreporting/kfconfiguration/mappings', code: 'admin.kfreporting.mappings'}
        ]
      },
      {
        title: 'KF REGISTRATION',
        code: 'kfregistration',
        pageTitle: 'KF Registration',
        pageSubtitle: 'All Registrations',
        breadcrumb_title: 'KF Registration',
        link: '/kfregistration/all-registrations',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'All Registrations', link: '/kfreporting/kfregistration/all-registrations', code: 'admin.kfreporting.all-registrations'},
          {title: 'Validation Center', link: '/kfreporting/kfregistration/validation-center', code: 'admin.kfreporting.validation-center'},
          // {title: 'Collection Streams', link: '/kfreporting/classifiers/collection-streams', code: 'collection-streams'}
        ]
      },
    ]
  } as NavMenuItem,
  {
    title: 'INTELLIGENCE REPORTING',
    code: 'intelligencereporting',
    roles: ['WF_ADMIN'],
    link: 'intelligencereporting',
    breadcrumb_title: 'Intelligence Reporting',
    class: '',
    submenus: [
      {
        title: 'QUESTIONS',
        code: 'questions',
        pageTitle: 'Questions',
        pageSubtitle: 'List of Questions',
        breadcrumb_title: 'Questions',
        link: 'questions/all',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Questions', link: '/intelligencereporting/questions/all', code: 'intelligencereporting.questions'},
          {title: 'Question Categories', link: '/intelligencereporting/questions/questioncategories', code: 'intelligencereporting.questioncategories'},
        ]
      },
      {
        title: 'ROUND OF QUESTIONS',
        code: 'roundofquestions',
        pageTitle: 'Round of Questions',
        pageSubtitle: 'List of Round of Questions',
        breadcrumb_title: 'Round of Questions',
        link: '/roundofquestions',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Round of Questions', link: '/intelligencereporting/roundofquestions', code: 'intelligencereporting.roundofquestions'},
        ]
      },
      {
        title: 'FORMS',
        code: 'forms',
        pageTitle: 'Forms',
        pageSubtitle: 'List of Forms',
        breadcrumb_title: 'Forms',
        link: '/forms/list',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Forms', link: '/intelligencereporting/forms/list', code: 'intelligencereporting.forms.list'},
          {title: 'Upload Answers', link: '/intelligencereporting/forms/upload', code: 'intelligencereporting.forms.upload'},
        ]
      }
    ]
  } as NavMenuItem,
  {
    title: 'ADMIN', code: 'admin', link: 'admin', roles: ['WF_ADMIN'], breadcrumb_title: 'Admin', class: '', submenus: [
      {
        title: 'USERS',
        code: 'users',
        pageTitle: 'Users',
        pageSubtitle: 'List of Users',
        breadcrumb_title: 'Users',
        link: '/users',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Users', link: '/admin/users', code: 'users'},
        ]
      },
      {
        title: 'COUNTRIES',
        code: 'countries',
        pageTitle: 'Countries',
        pageSubtitle: 'List of Countries',
        breadcrumb_title: 'Countries',
        link: '/countries/list',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Countries', link: '/admin/countries/list', code: 'admin.countries'},
          {title: 'Upload Population', link: '/admin/countries/upload', code: 'admin.countries.uploadpopulation'},
        ]
      },
      {
        title: 'WEEE SYSTEMS',
        code: 'weeesystems',
        pageTitle: 'WEEE Systems',
        pageSubtitle: 'List of WEEE Systems',
        breadcrumb_title: 'WEEE Systems',
        link: '/weeesystems',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of WEEE Systems', link: '/admin/weeesystems', code: 'weeesystems'},
        ]
      },
      {
        title: 'TEMPLATES',
        code: 'templates',
        pageTitle: 'Templates',
        pageSubtitle: 'List of Templates',
        breadcrumb_title: 'Templates',
        link: '/templates',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Templates', link: '/admin/templates', code: 'templates'},
        ]
      },
      {
        title: 'INFO BOXES',
        code: 'info-boxes',
        pageTitle: 'Info boxes',
        pageSubtitle: 'List of Info boxes',
        breadcrumb_title: 'Info boxes',
        link: '/info-boxes',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Info boxes', link: '/admin/info-boxes', code: 'info-boxes'},
        ]
      },
      {
        title: 'CHART EXPLANATIONS',
        code: 'chart-labels',
        pageTitle: 'Chart Explanations',
        pageSubtitle: 'List of Chart Explanations',
        breadcrumb_title: 'Chart Explanations',
        link: '/chart-labels',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Chart Explanations', link: '/admin/chart-labels', code: 'chart-labels'},
        ]
      },
      {
        title: 'ERROR MARGINS',
        code: 'error-margins',
        pageTitle: 'Error Margins',
        pageSubtitle: 'List of Error Margins',
        breadcrumb_title: 'Error Margins',
        link: '/error-margins',
        class: '',
        roles: ['WF_ADMIN'],
        submenus: [
          {title: 'List of Error Margins', link: '/admin/error-margins', code: 'error-margins'},
        ]
      },
    ]
  } as NavMenuItem,
];
export const BREADCRUMB_ITEMS = [
  {
    title: 'MAPPINGS',
    code: 'kfconfiguration',
    pageTitle: 'Kf Configuration',
    pageSubtitle: 'Mappings',
    breadcrumb_title: 'Kf Configuration',
    breadcrumb_subtitle: 'Mappings',
    class: '',
    help_item_code: 'kf_mappings'
  } as NavMenuItem
];

export const getMenuByCode = (code: string): NavMenuItem | undefined =>
  MENU_ITEMS.filter(item => item.code === code).pop();


export const getSubmenuByCode = (code: string, menu: NavMenuItem): NavMenuItem | undefined =>
  menu?.submenus?.filter(item => item.code === code).pop();

export const getBreadcrumbByTitle = (code: string): NavMenuItem | undefined =>
  BREADCRUMB_ITEMS.filter(item => item.code === code).pop();
